module.exports = __webpack_public_path__ + "img/moobel.12cc43d6.svg";